module.exports = "td{\r\n    border: 1px solid #ddd;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/khb-drawing/khb-drawing-grid/khb-drawing-grid.component.css
// module id = ./src/app/planning/khb-drawing/khb-drawing-grid/khb-drawing-grid.component.css
// module chunks = main